/**
 * Better Auth browser client. Safe to import from client components.
 * baseURL defaults to the current origin (auth handler is mounted at /api/auth).
 */
import { apiKeyClient } from '@better-auth/api-key/client'
import { adminClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  plugins: [adminClient(), organizationClient(), apiKeyClient()],
})

export const { signIn, signUp, signOut, useSession } = authClient
export const { useListOrganizations, useActiveOrganization } = authClient
export const organization = authClient.organization
